import { useSetting } from '@tencent/setting-vue-webpack-plugin';
var pageSetting = useSetting('页面配置', {
  页面标题: '',
  分享标题: '',
  分享描述: '',
  分享朋友圈标题: '',
  分享图: '',
  分享链接: ''
});
window.pageSetting = pageSetting;